import { Component } from '@angular/core';

@Component({
    selector: 'app-redirecting-loader',
    templateUrl: './redirecting-loader.component.html',
    styleUrl: './redirecting-loader.component.scss',
    standalone: false,
})
export class RedirectingLoaderComponent {}
